module.exports = __webpack_public_path__ + "img/REFRESH_STATUS.03556fb3.svg";